import { render, staticRenderFns } from "./FormVerify.vue?vue&type=template&id=97817d36&scoped=true"
import script from "./FormVerify.vue?vue&type=script&lang=js"
export * from "./FormVerify.vue?vue&type=script&lang=js"
import style0 from "./FormVerify.vue?vue&type=style&index=0&id=97817d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97817d36",
  null
  
)

export default component.exports